import React, { useState, useEffect, useContext } from 'react'
import ContainerHomePageText from '../../components/containerHomePageText/ContainerHomePageText'
import { useTranslation } from 'react-i18next'
import { ILoan, IFilteredLoans } from '../../interfaces/i-api-loan'
import { LoanType, SortPropType } from '../../constants/enums/LoanType'
import { ExpandableComponent } from '../../components/expandable/Expandable'
import SortingArrows from '../../components/SortingArrows'
import DownloadLoanDocumentButton from '../../components/downloadLoanDocumentButton/DownloadLoanDocumentButton'
import {
	getLoanInfo,
	getLoanHeader,
	getLoanPaymentInfo,
	downloadRepaymentplan,
	downloadSignedPromissoryNote,
	downloadPromissoryNote,
} from '../../utils/countryDataHelper'
import appConfig from '../../app.config'
import { CountryCode } from 'constants/countryTypes'
import { CookieType } from 'constants/cookieTypes'
import customerDataApiService from 'services/customerDataApiService'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Alert } from 'react-bootstrap'
import { getColor } from '../../utils/helpers'
import {
	getErrorWithFullMessage,
	checkIsMobile,
	logError,
	DocumentTypes,
} from 'exports'
import { Toggle } from '../../constants/enums/ToggleTypes'
import AppConfigContext from 'contexts/azureAppConfig'
import MyPagesCustomerInfoContext from 'contexts/MyPagesCustomerInfoContext'

interface IProps {
	onChangeValues: any
}

function Loans({ onChangeValues }: IProps) {
	const isMobile = checkIsMobile()
	const { t } = useTranslation()
	const [data, setData] = useState<IFilteredLoans[]>([])
	const [show, setShow] = useState(true)
	const [error, setError] = useState<Error>()
	const { toggle } = useContext(AppConfigContext)
	const { refreshCustomerContext } = useContext(MyPagesCustomerInfoContext)
	
	const getHeader = (props: any, loanType: LoanType) => {
		return (
			<>
				{getLoanHeader(loanType, t, props).map(
					(item: any, key: any) => {
						return (
							item.show &&
							(isMobile ? (
								item.isMobile && (
									<div
										key={key}
										className={`d-flex header-text ${appConfig.country ==='dk' ? 'header-column-dk' : 'header-column'}`}>
										{item.value}
									</div>
								)
							) : (
								<div
									key={key}
									className={`d-flex header-text ${appConfig.country ==='dk' ? 'header-column-dk' : 'header-column'}`}>
									{item.value}
								</div>
							))
						)
					}
				)}
			</>
		)
	}

	const hasData = () => Array.isArray(data) && data.length > 0

	const isLoading = () => !hasData() && show

	function sort(type: LoanType, sortOn: SortPropType, order: 'asc' | 'desc') {
		let index = data.findIndex((i) => i.loanType === type)
		let dataX = [...data][index].loans
		let sorted: ILoan[] = []
		if (order === 'asc') {
			switch (sortOn) {
				case 'agreementNumber':
				case 'unpaidInvoices':
					sorted = dataX.sort((a, b) => a[sortOn] - b[sortOn])
					break
				case 'externalPartnerName':
					sorted = dataX.sort((a, b) =>
						a[sortOn]
							.toString()
							.toLowerCase()
							.localeCompare(b[sortOn].toString().toLowerCase())
					)
					break
				default:
					sorted = dataX.sort((a, b) => {
						return (
							+new Date(a.latestDisbursementDate) -
							+new Date(b.latestDisbursementDate)
						)
					})
			}
		} else if (order === 'desc') {
			switch (sortOn) {
				case 'agreementNumber':
				case 'unpaidInvoices':
					sorted = dataX.sort((a, b) => b[sortOn] - a[sortOn])
					break
				case 'externalPartnerName':
					sorted = dataX.sort((a, b) =>
						b[sortOn]
							.toLowerCase()
							.localeCompare(a[sortOn].toLowerCase())
					)
					break
				default:
					sorted = dataX.sort((a, b) => {
						return (
							+new Date(b.latestDisbursementDate) -
							+new Date(a.latestDisbursementDate)
						)
					})
			}
		}
		let items = [...data]
		let item = {
			...items[index],
			loans: sorted,
		}
		items[index] = item
		setData(items)
	}

	function getChildData(loan: ILoan, loanType: LoanType, color: string) {
		const buttonStyle = {
			fontSize: '1.6rem',
			backgroundColor: '#de996f',
			color: '#6B2900',
			borderRadius: '0.8rem',
			fontWeight: '600',
			border: 'none',
			outline: 'none',
			padding: '1rem 2.4rem',
			width: '100%',
		}

		const styleHover = {
			fontSize: '1.6rem',
			backgroundColor: '#eea87e',
			color: '#6B2900',
			borderRadius: '0.8rem',
			fontWeight: '600',
			border: 'none',
			outline: 'none',
			padding: '1rem 2.4rem',
			width: '100%',
		}

		return (
			<div
				className={
					isMobile
						? 'home-page-container-collapse'
						: 'home-page-container-collapse d-flex flex-row'
				}
				style={{
					border: '1px solid #e9e8da', // Cream dark
					borderLeft: `3px solid ${color}`,
				}}>
				<div
					id="invoice"
					style={{
						width: isMobile ? '100%' : '55%',
					}}
					className={'pl-3 pr-4 py-3'}>
					<div className="pt-3 pb-3">
						<b>{t('PaymentInformation')}</b>
					</div>

					{getLoanPaymentInfo(loan, t).map((item: any, key: any) => {
						return (
							item.show && (
								<ContainerHomePageText
									xs={[6, 6]}
									left={item.text}
									right={item.value}
									tooltip={item.tooltip}
									key={key}
								/>
							)
						)
					})}
						{loan &&
							loan.unpaidInvoiceLink && (
								<div className="mt-5 mr-3">
									<div className="mb-4">
										<a
											className="btn-primary btn pageLinksBtn"
											href={
												loan.unpaidInvoiceLink
											}
											target="_blank"
											rel="noreferrer">
											{t('PayInvoice')}
										</a>
									</div>
								</div>
							)}
					{loan.dpd > 0 && 
						(appConfig.country !== 'fi' || !loan.isPaymentHolidayPossible) && (
							<div className="mt-5 alert alert-danger">
								{t('PastDueDate', { dpd: loan.dpd })}
							</div>
					)}
				</div>

				<div
					id="loan-stuff"
					style={{
						width: isMobile ? '100%' : '45%',
					}}
					className={'pl-3 pr-4 py-3'}>
					<div className="pt-3 pb-3">
						<b>{t('LoanInformation')}</b>
					</div>

					{getLoanInfo(loan, loanType, t).map(
						(item: any, key: any) => {
							return (
								item.show && (
									<div key={key}>
										<ContainerHomePageText
											xs={[6, 6]}
											left={item.text}
											right={item.value}
											tooltip={item.tooltip}
										/>
									</div>
								)
							)
						}
					)}
					{(downloadRepaymentplan(loan) ||
						downloadSignedPromissoryNote(loan) ||
						downloadPromissoryNote(loan)) && (
						<div className="mt-5 mr-3">
							{downloadRepaymentplan(loan) && (
								<div className="mb-4">
									<DownloadLoanDocumentButton
										repaymentPlanId={loan.repaymentPlanID}
										style={buttonStyle}
										styleHover={styleHover}
										icon={'download'}
									/>
								</div>
							)}
							{downloadSignedPromissoryNote(loan) && (
								<div className="mb-4">
									<DownloadLoanDocumentButton
										style={buttonStyle}
										styleHover={styleHover}
										icon={'download'}
										documentInfo={loan.documentsInfo.find(
											(x) =>
												x.type ===
												DocumentTypes.SignedPromissoryNote
										)}
									/>
								</div>
							)}
							{downloadPromissoryNote(loan) && (
								<div className="mb-4">
									<DownloadLoanDocumentButton
										style={buttonStyle}
										styleHover={styleHover}
										icon={'download'}
										documentInfo={loan.documentsInfo.find(
											(x) =>
												x.type ===
												DocumentTypes.PromissoryNote
										)}
									/>
								</div>
							)}
						</div>
					)}
				</div>
			</div>
		)
	}

	function getChildDataWithProducts(
		loans: ILoan[],
		color: string,
		loanType: LoanType
	) {
		return (
			<div className="d-flex flex-column column-wrap">
				<div
					style={{
						backgroundColor: '#f9f8f3', // Cream light
						border: '.5px solid #e9e8da', // Cream dark
						borderLeft: `3px solid ${color}`,
					}}
					className="home-page-container-expand">
					<div className="d-flex align-items-center justify-content-between h-100">
						{getLoanHeader(loanType, t).map(
							(item: any, key: any) => {
								return (
									item.show &&
									(isMobile ? (
										item.isMobile && (
											<div
												key={key}
												className={`d-flex header-text ${appConfig.country === "dk"? 'header-column-dk': 'header-column'}`}>
												<b>{t(item.text)}</b>
											</div>
										)
									) : (
										<div
											key={key}
											className={`d-flex align-items-center header-text ${appConfig.country === 'dk'? 'header-column-alt': 'header-column'}`}>
											<b>{t(item.text)}</b>
											{loanType !== LoanType.Cash && (
												<SortingArrows
													sortAsc={() =>
														sort(
															loanType,
															item.sortStr,
															'asc'
														)
													}
													sortDesc={() =>
														sort(
															loanType,
															item.sortStr,
															'desc'
														)
													}
												/>
											)}
										</div>
									))
								)
							}
						)}
						<div style={{ width: '35px' }} className="d-flex"></div>
					</div>
				</div>
				{loans.map((loan, key) => (
					<ExpandableComponent
						className="w-100"
						key={key}
						id={key}
						children={getChildData(loan, loanType, color)}
						onClick={() => {}}
						content={getHeader(loan, loanType)}
						backgroundColor={'#f9f8f3'} // Cream light
						color={color}
						expanded = {appConfig.country === "no"}
					/>
				))}
			</div>
		)
	}

	async function getLoans() {
		let country = appConfig.country as keyof typeof CountryCode
		let data = sessionStorage.getItem(CookieType.LoanInfo)
		if (data) {
			setData(JSON.parse(data))
			refreshCustomerContext()
			if (data === '[]') setShow(false)
		} else {
			try {
				let data = await customerDataApiService.getLoanData(
					CountryCode[country],
					t
				)
				setData(data as IFilteredLoans[])
				sessionStorage.setItem(
					CookieType.LoanInfo,
					JSON.stringify(data)
				)
				if (data?.length === 0) setShow(false)
				refreshCustomerContext()
			} catch (error) {
				logError(error as Error)
				setError(getErrorWithFullMessage(error as Error))
				setShow(false)
			}
		}
	}

	useEffect(() => {
		toggle.includes(Toggle.loans) ? getLoans() : setShow(false)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {}, [data])

	useEffect(() => {
		onChangeValues(show, error)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [show, error])

	return (
		<div className={'mb-2'}>
			{hasData() || isLoading() ? (
				<ExpandableComponent
					key={'Loans'}
					id={1}
					children={data.map(
						({ loanType, loans }: IFilteredLoans, key) => (
							<ExpandableComponent
								className="type"
								key={key}
								id={key}
								children={getChildDataWithProducts(
									loans,
									getColor(loanType, data),
									loanType
								)}
								onClick={() => {}}
								backgroundColor={'#efeee3'} // Cream rich
								color={getColor(loanType, data)}
								expanded = {appConfig.country === "no"}
								content={getHeader(
									LoanType[loanType],
									loanType
								)}
							/>
						)
					)}
					onClick={() => {}}
					backgroundColor={'#efeee3'} //  Cream rich
					color={'#c87d5a'} // Thick border left color: Bronze red
					content={
						<div className="d-flex ml-4" style={{ width: '100%' }}>
							<div className="d-flex">
								<FontAwesomeIcon
									style={{ color: '#575651' }} // Warm Gray 11
									icon={'file-invoice'}
									className="ml-1 home-icon"
								/>
								<div className="ml-3">{t('Loans')}</div>
							</div>
							{isLoading() && (
								<div className="loading d-flex ml-auto mr-5 mb-2"></div>
							)}
						</div>
					}
					expanded={hasData()}
					chevron={!isLoading()}
				/>
			) : (
				error && (
					<Alert variant="danger" className="mt-2 mb-4">
						{error?.message}
					</Alert>
				)
			)}
		</div>
	)
}

export default Loans
